"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListItem = exports.StyledList = exports.StyledListWrapper = exports.Arrow = exports.Title = exports.Header = exports.Label = exports.Container = void 0;

const styled_components_1 = __importStar(require("styled-components"));

const constants_1 = require("./constants");

const Label_1 = __importDefault(require("../Label"));

exports.Container = styled_components_1.default.div`
  width: auto;
  height: auto;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
  ${props => props.theme.isMobile && (0, styled_components_1.css)`
      position: relative;
    `}
`;
exports.Label = (0, styled_components_1.default)(Label_1.default)`
  display: inline-block;
  margin-bottom: 8px;
`;
exports.Header = styled_components_1.default.div`
  width: 12rem;
  height: 1.875rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: ${props => props.theme.fontSizes[14]};
  user-select: none;
  border: 1px solid
    ${props => props.isOpen ? props.theme.colors.primary_700_main : props.theme.colors.beige_400};
  border-radius: 4px;
  padding: 0 8px 0 10px;

  ${props => props.disabled && (0, styled_components_1.css)`
      cursor: not-allowed;
      background-color: ${props.theme.colors.gray_201};
      border-color: ${props.theme.colors.gray_201};
    `}
  ${props => props.theme.isMobile ? (0, styled_components_1.css)`
          width: 100%;
          border-width: 2px;
          height: 48px;
          svg {
            transform: scale(1.5);
          }
        ` : (0, styled_components_1.css)`
          &:hover {
            border-color: ${!props.disabled && props.theme.colors.primary_700_main};
          }
        `}
`;
exports.Title = styled_components_1.default.span`
  white-space: nowrap;
  color: ${props => props.disabled ? props.theme.colors.gray_401 : props.theme.colors.black};
  opacity: ${props => props.disabled ? 1 : 0.7};
  line-height: ${props => props.theme.lineHeights[16]};
  font-family: 'Roboto', sans-serif;
  font-size: ${props => props.theme.fontSizes[12]};
  overflow: hidden;
  text-overflow: ellipsis;
  ${props => props.theme.isMobile && (0, styled_components_1.css)`
      font-size: 16px;
    `}
`;
exports.Arrow = styled_components_1.default.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => props.isOpen && (0, styled_components_1.css)`
      transform: rotate(180deg);
    `}
  ${props => props.theme.isMobile && (0, styled_components_1.css)`
      width: 25px;
    `}
`;
exports.StyledListWrapper = styled_components_1.default.div`
  position: absolute;
  padding-right: ${props => props.count && props.count > constants_1.MAX_DROPDOWN_LIST_ITEMS ? '5px' : 0};
  width: 12rem;
  box-shadow: 0 3px 5px #00000029;
  background-color: ${props => props.theme.colors.white};
  z-index: 1;
  border-radius: 4px;
  margin-top: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  ${props => props.theme.isMobile && (0, styled_components_1.css)`
      width: auto;
      left: 0;
      right: 0;
    `}
`;
exports.StyledList = styled_components_1.default.ul`
  display: block;
  width: 100%;
  max-height: ${38 * constants_1.MAX_DROPDOWN_LIST_ITEMS + 10}px;
  overflow: auto;
  position: relative;
  font-size: ${props => props.theme.fontSizes[14]};
  user-select: none;
  margin: 0;
  padding: 0;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-track-piece:start {
    background: transparent;
    margin-top: 4px;
  }

  &::-webkit-scrollbar-track-piece:end {
    background: transparent;
    margin-bottom: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.15);
    outline: 1px solid rgba(0, 0, 0, 0.15);
    min-height: 40px;
    max-height: 40px;
    border-radius: 9999px;
  }
`;
exports.StyledListItem = styled_components_1.default.li`
  width: 100%;
  list-style: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0;
  cursor: pointer;
  padding: 10px;
  box-sizing: border-box;
  height: 38px;

  & label {
    margin: 0;
  }
  ${props => props.theme.isMobile ? (0, styled_components_1.css)`
          height: 24px;
          margin: 20px 0;
        ` : (0, styled_components_1.css)`
          &:hover {
            background: ${props.theme.colors.primary_700_main + '0d'};
          }
        `}
`;